module.exports = __webpack_public_path__ + "img/logo.2148a8a9.svg";